import { isOptionInstrument } from '../../../tradeplans/activeTradePlanModule/utils/optionInstrument';

export const resolveBidAskChartSymbol = (tradePlan) =>
  isOptionInstrument(tradePlan?.instrument)
    ? tradePlan?.positionSymbol
    : tradePlan?.symbol;
